/** Display formatting for the Availability tables, matching the Figma comp. */

export const pct = (n: number | null, dp = 1): string =>
  n == null ? '—' : `${n.toFixed(dp)}%`;

export const count = (n: number | null): string =>
  n == null ? '—' : Math.round(n).toLocaleString('en-IN');

export const days = (n: number | null): string =>
  n == null ? '—' : `${Math.round(n)} days`;

/** Deltas render parenthesised and signed, e.g. "(+1.5%)" / "(-4)". */
export const deltaPct = (n: number | null, dp = 1): string | undefined =>
  n == null ? undefined : `(${n >= 0 ? '+' : '−'}${Math.abs(n).toFixed(dp)}%)`;

export const deltaNum = (n: number | null): string | undefined =>
  n == null ? undefined : `(${n >= 0 ? '+' : '−'}${Math.abs(Math.round(n))})`;

export const direction = (n: number | null): 'up' | 'down' | undefined =>
  n == null ? undefined : n >= 0 ? 'up' : 'down';

/** City names arrive lower-cased from the warehouse; the UI presents them cased. */
export function titleCase(v: string | undefined): string | undefined {
  return v?.replace(/\b[a-z]/g, (c) => c.toUpperCase());
}
